<template>
    <div class="events_dropdown w-full">
        <app-dropdown>
            <app-dropdown-list
                class="!block w-full"
                placement="bottom-start"
                offsetDistance="4"
            >
                <template #dropdownBtn>
                    <div
                        class="events_dropdown__btn"
                        :class="[
                            selectedItems.length > 0
                                ? '!text-white !bg-black-900 !border-transparent !max-content'
                                : '',
                        ]"
                    >
                        <div class="selected_item">
                            <div class="selected_item_list flex">
                                <div
                                    class="text-gray-300 font-medium leading-4"
                                    :class="[
                                        selectedItems.length > 0
                                            ? '!hidden'
                                            : '',
                                    ]"
                                >
                                    <span>{{ inputHolder }}</span>
                                </div>
                                <div
                                    class="text-gray-300 font-medium leading-4 flex"
                                    :class="[
                                        selectedItems.length > 0
                                            ? '!text-white bg-black-900'
                                            : '',
                                    ]"
                                >
                                    <template v-if="selectedItems.length === 1">
                                        <span>{{ selectedItems[0].name }}</span>
                                    </template>
                                    <template
                                        v-else-if="selectedItems.length > 1"
                                    >
                                        <span>
                                            {{ selectedItems[0].name }} and
                                            {{ selectedItems.length - 1 }} more
                                        </span>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <fa
                            class="events_dropdown__icon ml-auto"
                            :icon="['fal', 'angle-down']"
                            :class="[
                                selectedItems.length > 0 ? '!text-white' : '',
                            ]"
                        ></fa>
                    </div>
                </template>
                <template #content="{ close }">
                    <div class="search_filter__autocomplete">
                        <div class="search_input__group">
                            <span class="search_input__icon">
                                <fa :icon="['fal', 'magnifying-glass']"></fa>
                            </span>
                            <input
                                type="text"
                                v-model="searchText"
                                class="search_autocomplete__input"
                                placeholder="Search..."
                            />
                        </div>
                        <div class="auto_wrapper p-4">
                            <div class="dropdown-section selected_search">
                                <div
                                    v-for="item in selectedItems"
                                    :key="item.value"
                                    class="p-2 mb-[0.125rem] hover:bg-gray-100 rounded-lg cursor-pointer"
                                >
                                    <app-checkbox
                                        isFull
                                        :id="id + item.value"
                                        :checked="item.isChecked"
                                        @click.stop.prevent="deselectItem(item)"
                                    >
                                        <template #checkboxLabel>
                                            <label
                                                :for="id + item.value"
                                                class="text-sm font-normal text-dark-100 italic flex"
                                                >{{ item.label }}</label
                                            >
                                        </template>
                                    </app-checkbox>
                                </div>
                                <button
                                    class="p-2 mb-[0.125rem] hover:bg-gray-100 rounded-lg text-sm cursor-pointer italic block w-full text-left"
                                    @click="deselectItem(null, true)"
                                    v-if="selectedItems.length"
                                >
                                    Clear all
                                </button>
                            </div>
                            <div class="dropdown-section">
                                <h4
                                    class="text-xs font-bold text-gray-300 uppercase p-2"
                                >
                                    Suggestions
                                </h4>
                                <div
                                    v-for="item in filteredSelectable"
                                    :key="item.value"
                                    class="p-2 hover:bg-gray-100 rounded-lg cursor-pointer"
                                >
                                    <app-checkbox
                                        isFull
                                        :id="
                                            id + item.value
                                                ? id + item.value
                                                : id + item.id
                                        "
                                        :checked="item.isChecked"
                                        @click.stop.prevent="selectItem(item)"
                                    >
                                        <template #checkboxLabel>
                                            <label
                                                class="text-sm font-normal text-dark-100 italic flex"
                                                :for="
                                                    id + item.value
                                                        ? id + item.value
                                                        : id + item.id
                                                "
                                            >
                                                {{ item.label }}
                                            </label>
                                        </template>
                                    </app-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </app-dropdown-list>
        </app-dropdown>
    </div>
</template>
<script setup>
import { ref, toRef, onMounted, computed, watch } from 'vue';
import AppDropdown from '@/components/dropdown/AppDropdown.vue';
import AppDropdownList from '@/components/dropdown/AppDropdownList.vue';
import AppCheckbox from '../forms/AppCheckbox.vue';
import { useAppSearchStore } from '@/stores/appSearchStore';
import { storeToRefs } from 'pinia';
const emits = defineEmits(['checkLabelValue', 'unCheckLabelValue']);
const props = defineProps({
    selectedArray: {
        type: Array,
        default: () => [],
    },
    eventsArray: {
        type: Array,
        default: () => [],
    },
    id: {
        type: String,
        default: 'events',
    },
    allEventId: {
        type: String,
        default: 'allEvents',
    },
    eventName: {
        type: String,
        default: 'events',
    },
    allEventsName: {
        type: String,
        default: 'allEvents',
    },
    labelText: {
        type: String,
        default: 'Event',
    },
    isClose: {
        type: Boolean,
        default: false,
    },
    filterText: {
        type: String,
        default: '',
    },
    inputHolder: {
        type: String,
        default: '',
    },
    searchPlaceholder: {
        type: String,
        default: '',
    },
});
// search store
const searchStore = useAppSearchStore();
const { filterObj, currentTab } = storeToRefs(searchStore);
const searchText = ref('');

// const checkedItems = ref([]);
// const propArray = toRef(props, 'eventsArray');
const items = ref(JSON.parse(JSON.stringify(props.eventsArray)));
watch(toRef(props, 'eventsArray'), (newVal) => {
    items.value = newVal.map((obj) => {
        const isChecked = filterObj.value[currentTab.value].checkedItems.some(
            (checkedItem) =>
                checkedItem.id === obj.id ||
                checkedItem.board_id === obj.board_id ||
                checkedItem.event_id === obj.event_id ||
                checkedItem.label_id === obj.label_id ||
                checkedItem.user_id === obj.user_id
        );
        return {
            id:
                obj.user_id ||
                obj.contact_type_id ||
                obj.event_id ||
                obj.label_id ||
                obj.board_id,
            name: obj.label ? obj.label : obj.name,
            board_id: obj.board_id ? obj.board_id : '',
            label: obj.name,
            isChecked: isChecked,
            value:
                obj.user_id ||
                obj.contact_type_id ||
                obj.event_id ||
                obj.label_id ||
                obj.board_id,
            user_id: obj.user_id ? obj.user_id : '',
            contact_type_id: obj.contact_type_id ? obj.contact_type_id : '',
            label_id: obj.label_id ? obj.label_id : '',
            event_id: obj.event_id ? obj.event_id : '',
        };
    });
});

const selectedItems = computed(() =>
    items.value.filter((item) => item.isChecked)
);

const selectableItems = computed(() =>
    items.value.filter((item) => !item.isChecked)
);
const filteredSelectable = computed(() => {
    if (!searchText.value) return selectableItems.value;
    return selectableItems.value.filter((item) =>
        item.name.toLowerCase().includes(searchText.value.toLowerCase())
    );
});

const selectItem = (item) => {
    const index = items.value.findIndex(
        (i) =>
            i.value === item.value &&
            i.board_id === item.board_id &&
            i.user_id === item.user_id &&
            i.label_id === item.label_id
    );
    items.value[index].isChecked = true;

    if (selectedItems.value.length) {
        for (let i = 0; i < selectedItems.value.length; i++) {
            // Check if item is not already in the checkedItems array considering value, board_id, user_id, and label_id
            if (
                !filterObj.value[currentTab.value].checkedItems.some(
                    (checkedItem) =>
                        checkedItem.value === selectedItems.value[i].value &&
                        checkedItem.board_id ===
                            selectedItems.value[i].board_id &&
                        checkedItem.user_id ===
                            selectedItems.value[i].user_id &&
                        checkedItem.label_id === selectedItems.value[i].label_id
                )
            ) {
                // Push the item along with its board_id, user_id, and label_id
                filterObj.value[currentTab.value].checkedItems.push({
                    ...selectedItems.value[i],
                    board_id: selectedItems.value[i].board_id
                        ? selectedItems.value[i].board_id
                        : '',
                    user_id: selectedItems.value[i].user_id
                        ? selectedItems.value[i].user_id
                        : '',
                    label_id: selectedItems.value[i].label_id
                        ? selectedItems.value[i].label_id
                        : '',
                });
            }
        }
    }

    let filterCheckedItems = filterObj.value[
        currentTab.value
    ].checkedItems.filter((item, index, array) => {
        return (
            array.findIndex(
                (obj) =>
                    obj.value === item.value &&
                    obj.board_id === item.board_id &&
                    obj.user_id === item.user_id &&
                    obj.label_id === item.label_id
            ) === index
        );
    });

    items.value = [...items.value];
    emits('checkLabelValue', filterCheckedItems);
};

const deselectItem = (item, deselectAll = false) => {
    console.log('working only once deselectItem');
    const processItem = (item) => {
        const hasNeededProps = [
            'label_id',
            'event_id',
            'user_id',
            'board_id',
        ].some((prop) => Object.prototype.hasOwnProperty.call(item, prop));

        if (hasNeededProps) {
            const index = items.value.findIndex((i) => i.value === item.value);
            if (index !== -1) {
                items.value[index].isChecked = false;
                items.value = [...items.value];
            }

            const indexInCheckedItems = filterObj.value[
                currentTab.value
            ].checkedItems.findIndex(
                (i) =>
                    i.id === item.id &&
                    ((i.label_id && i.label_id === item.label_id) ||
                        (i.event_id && i.event_id === item.event_id) ||
                        (i.user_id && i.user_id === item.user_id) ||
                        (i.board_id && i.board_id === item.board_id))
            );
            if (indexInCheckedItems !== -1) {
                filterObj.value[currentTab.value].checkedItems.splice(
                    indexInCheckedItems,
                    1
                );
            }
            emits('unCheckLabelValue', item, 'contact');
        }
    };

    if (deselectAll) {
        items.value.forEach(processItem);
    } else {
        processItem(item);
    }
};

const deselectAll = () => {
    console.log('deselect')
    items.value.forEach((item) => {
        item.isChecked = false;
    });

    // Deselect all check boxes
    let currentTabFilter = filterObj.value[currentTab.value];

    // Remove all the checked items
    currentTabFilter.checkedItems = [];

    // Remove all the specified properties
    ['board_id', 'label_id', 'contact_type_id', 'user_id'].forEach(
        (property) => {
            if (currentTabFilter.hasOwnProperty.call(property)) {
                currentTabFilter[property] = [];
            }
        }
    );

    // Re-render the items
    items.value = [...items.value];
};
onMounted(() => {});
defineExpose({ deselectAll });
</script>
<style scoped>
.events_dropdown {
    @apply inline-block;
}

.events_dropdown__btn {
    @apply rounded border border-gray-100 bg-white dark:bg-gray-500 dark:text-white dark:border-black-900 flex items-center h-auto px-3 py-[0.4375rem];
    width: max-content;
}
.selected_item_list {
    @apply text-black-900 text-sm mr-2;
}
.selected_item_list svg {
    @apply mr-1;
}

.events_dropdown__img {
    @apply w-[2.1875rem] h-auto mr-2;
}

.events_dropdown__text {
    @apply text-sm text-dark-100 mr-3;
}

.events_dropdown__icon {
    @apply text-sm text-gray-500;
}

.events_dropdown__wrapper {
    @apply min-w-[410px] max-w-full bg-white p-4 rounded shadow-dropdown ltr:text-left rtl:text-right;
}

.events_dropdown__countries {
    @apply grid grid-cols-2 md:grid-cols-3 items-center gap-6 border-b border-gray-200 pb-6 mb-6;
}

.events_dropdown__wrapper_btn {
    @apply border border-gray-200 rounded text-center flex flex-col items-center justify-center h-[5rem];
}

.events_dropdown__wrapper_btn.active {
    @apply border-blue-500;
}

.events_dropdown__wrapper_img {
    @apply max-w-[2.375rem] h-auto;
}

.events_dropdown__wrapper_text {
    @apply text-sm text-dark-200;
}

.events_dropdown__label {
    @apply text-sm text-dark-200 mb-1.5 inline-block;
}

.events_dropdown__select {
    @apply w-full rounded border border-gray-200 bg-gray-100 dark:bg-gray-500 dark:border-black-900 dark:text-white h-10;
}
.events_dropdown__list {
    @apply py-6 first:pt-0 last:pb-0 last:border-b-0 flex items-center border-b border-gray-200 cursor-pointer;
}
.events_dropdown__list > img {
    @apply mr-2;
}
.checkbox {
    @apply w-6 h-6 rounded bg-gray-100 border border-gray-200 flex relative mr-1;
}
li.checked .checkbox::after {
    content: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.9766 0.648438C13.332 0.976562 13.332 1.55078 12.9766 1.87891L5.97656 8.87891C5.64844 9.23438 5.07422 9.23438 4.74609 8.87891L1.24609 5.37891C0.890625 5.05078 0.890625 4.47656 1.24609 4.14844C1.57422 3.79297 2.14844 3.79297 2.47656 4.14844L5.34766 7.01953L11.7461 0.648438C12.0742 0.292969 12.6484 0.292969 12.9766 0.648438Z' fill='black'/%3E%3C/svg%3E");
    @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%];
}
.list_box {
    @apply !p-0;
}
.search_input__group {
    @apply w-full h-[49px] flex items-center bg-white border-b border-gray-200 text-sm font-normal;
}
.search_input__group input {
    @apply focus-visible:outline-none focus:outline-none;
}
.search_input__icon {
    @apply text-base text-gray-300 p-4 pr-0 mr-2.5;
}
.search_filter__autocomplete {
    @apply shadow-dropdown dark:shadow-dropdownDark bg-white dark:bg-dark-100 min-w-[18rem] sm:min-w-[20rem] rounded-lg max-h-[calc(100vh-120px)] overflow-y-auto;
}
.search_filter__autocomplete ul {
    @apply !shadow-none !px-4 !py-4;
}
.selected_search ul {
    @apply !p-0;
}
</style>
